import { z } from 'zod';

import i18n from '@/lib/i18n';

export const loginSchema = z.object({
  email: z.string().min(1, i18n.t('validation.login.emailRequired')).email(i18n.t('validation.login.emailInvalid')),
  password: z.string().min(1, i18n.t('validation.login.passwordRequired')),
});

export type LoginFormData = z.infer<typeof loginSchema>;
